/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OrderStatus {
    CHECK_FAIL = 'check_fail',
    DONE = 'done',
}
